import React, { Component } from "react";
import { Switch, Route, Link } from "react-router-dom";
import AddVehicle from "./AddVehicle.js";
import UpdateVehicle from "./UpdateVehicle.js";
import VehicleDetails from "./VehicleDetails";
import TableList from "./Setup.jsx";
import InspectionReportView from "./InspectionReportView.js";

class FleetRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/company" component={TableList} />
        <Route exact path="/company/add-vehicle" component={AddVehicle} />
        <Route exact path="/company/edit/:vId" component={UpdateVehicle} />
        <Route exact path="/company/vehicle/:vId" component={VehicleDetails} />
        <Route
          exact
          path="/company/vehicle/inspection/:iId"
          component={InspectionReportView}
        />
      </Switch>
    );
  }
}

export default FleetRoutes;



// WEBPACK FOOTER //
// ./src/views/Company/FleetRoutes.js